export default __webpack_public_path__ + "static/media/src1_pitchnet.aed70eb3.mp3";